export default __webpack_public_path__ + "static/media/Loder.cf70d122.gif";